import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import {
  OL_COLOUR_KELP,
  OL_COLOUR_NAVY_BABY,
  OL_COLOUR_TOMAHTO,
} from '../../Style/colours';

const PROGRESS_BAR_COLOURS: { [key: string]: string } = {
  0: OL_COLOUR_NAVY_BABY,
  1: OL_COLOUR_KELP,
};

const PROGRESS_BAR_BORDER_RADIUS = 4;

interface ProgressProps {
  values: number[];
  max: number | null;
}

const Container = styled('div')({
  overflow: 'hidden',
  width: '100%',
  height: 15,
  borderRadius: PROGRESS_BAR_BORDER_RADIUS,
  backgroundColor: '#CACACA',
  display: 'flex',
});

const ProgressKeyContainer = styled('div')({
  height: '100%',
});

export const Progress = ({ values, max }: ProgressProps): ReactElement => {
  const keys: ReactElement[] = values.map((value: number, key: number) => {
    const ProgressItem = styled(ProgressKeyContainer)({
      backgroundColor:
        max && value >= max && values.length === 1
          ? OL_COLOUR_TOMAHTO
          : PROGRESS_BAR_COLOURS[key.toString()],
      width: max ? `${(value / max) * 100}%` : '100%',
    });

    return <ProgressItem key={`progress-bar-element-${key + 1}`} />;
  });

  return (
    <>
      <Container>{keys}</Container>
    </>
  );
};
